/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');
    

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');
    
    var xPosition = currentIndex * 50;

    $buttons.parent().css({
      transform: 'translate3d(-' + xPosition + '%, 0, 0)'
    });
    
    $('.slideshow__text-content-mobile').eq(currentIndex).show();
    $('.slideshow__text-content-mobile').not(':eq(' + currentIndex + ')').hide();

  }, 5000)

};

sections.extend('slideshow', slideshowAutoExtension);